module.exports = __webpack_public_path__ + "static/media/fontello.d6085cdf.woff";


//////////////////
// WEBPACK FOOTER
// ./src/font/fontello.woff?8095705
// module id = 332
// module chunks = 0